import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExpandMoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"expand_more"}/>
}
